import React, { FC } from 'react';
import { Grid } from '@mui/material';
import { StatisticCardSkeleton } from './statistic-card-skeleton';

export const StatisticsGridSkeleton: FC = () => {
  return (
    <Grid size={{ xs: 12, sm: 6 }}>
      <Grid container spacing={2}>
        {Array.from({ length: 9 }).map((_, index) => (
          <Grid size={{ xs: 6, sm: 12 / 3 }} key={index}>
            <StatisticCardSkeleton />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
